import * as React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import moment from 'moment';
import { Helmet } from 'react-helmet-async';
import MobileOrderCard from '../mobileComponents/mobileOrders/MobileOrderCard';
import MobileLoading from '../mobileComponents/mobileLoading/MobileLoading';
import { fetchUserOrder } from '../../apiCalls/urls/urlFunction';

export default function MobileOrders() {
    const [value, setValue] = React.useState(0);
    const [loading, setLoading] = React.useState(true);
    const [orders, setOrders] = React.useState([]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // 🔥 SAME PATTERN AS DESKTOP
    const fetchOrders = async () => {
        setLoading(true);
        const response = await fetchUserOrder();
        if (response?.status) {
            setOrders(response?.data?.orders ?? []);
        }
        setLoading(false);
    };

    React.useEffect(() => {
        fetchOrders();
    }, []);

    // ✅ SAFE FILTERS
    const completedOrders = orders.filter((o) => o?.status === 'COMPLETED');
    const failedOrders = orders.filter((o) => o?.status === 'FAILED');
    const otherOrders = orders.filter((o) => o?.status !== 'COMPLETED' && o?.status !== 'FAILED');

    return (
        <Box sx={{ width: '100%', bgcolor: 'white.main', pt: 3 }}>
            <Helmet>
                <title>Orders Page - 99gift.ae</title>
            </Helmet>

            <Tabs value={value} onChange={handleChange} variant="fullWidth">
                <Tab label="All" />
                <Tab label="Success" />
                <Tab label="Failed" />
                <Tab label="Others" />
            </Tabs>

            {loading ? (
                <Box sx={{ pt: 8 }}>
                    <MobileLoading />
                </Box>
            ) : (
                <>
                    <Box sx={{ px: 2, pt: 2, pb: 6 }}>
                        {value === 0 && <MobileOrderCard ordersData={orders} showVoucher />}
                        {value === 1 && <MobileOrderCard ordersData={completedOrders} showVoucher />}
                        {value === 2 && <MobileOrderCard ordersData={failedOrders} />}
                        {value === 3 && <MobileOrderCard ordersData={otherOrders} />}
                    </Box>
                </>
            )}
        </Box>
    );
}
